import {
  Grid,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Chip,
  Stack,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import Select from "react-select";
// import Select from "@mui/material/Select";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { Link } from "react-router-dom";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import { useDispatch } from "react-redux";
import * as XLSX from 'xlsx';


function Filter(props) {
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState("");
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [reportingManager, setReportingManager] = useState([]);
  const [selectDept, setSelectDept] = useState("");
  const [selectLocation, setSelectLoc] = useState("");
  const [selectManager, setSelectManager] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isKeywordError, setIsKeywordError] = useState(false);
  const [deptIds, setDeptsId] = useState("");
  const [locaIds, setLocaId] = useState("");
  const [managerIds, setManagerIds] = useState("");
  const [selectAlpha, setSelectAlpha] = useState(null);
  const [isDownloadable, setIsDownloadable] = useState(false);

  useEffect(() => {
    fetchDepartmentLookup();
    fetchLocationLookup();
    fetchReportingManagerLookup({
      "departmentId": 0,
      "teamId": 0
    });
  }, []);
  useEffect(() => {
    if (props.alphabet === null) {
      setSelectAlpha(null)
    }
    else {
      setSelectAlpha(props.alphabet)
    }
  }, [props.alphabet])

  useEffect(() => {
    if (props.isData === true) {
      setIsDownloadable(false)
    }
    else {
      setIsDownloadable(true)
    }
  }, [props.isData])
  const fetchDepartmentLookup = () => {
    axiosFetch({
      method: "GET",
      url: "/lookup/departments",
    })
      .then((res) => {
        if (res.status === 200) {
          setDepartments(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchLocationLookup = () => {
    axiosFetch({
      method: "GET",
      url: "/lookup/locations",
    })
      .then((res) => {
        if (res.status === 200) {
          setLocations(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchReportingManagerLookup = (req) => {
    axiosFetch({
      method: "POST",
      url: "/lookup/reportingmanagers",
      requestConfig: req
    })
      .then((res) => {
        if (res.status === 200) {
          setReportingManager(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleInactiveUser = (event) => {
    if (event.target.checked) {
      setIsActive(false);
      props.showInactive(false);
    } else {
      setIsActive(true);
      props.showInactive(true);
    }
  };
  const resetFilter = () => {
    setIsDownloadable(false)
    // props.onAlphaSearch(null)
    props.selectDepartment("");
    props.selectLoation("");
    props.selectManager("");
    setIsError(false);
    setIsKeywordError(false);
    setSelectDept("");
    setSelectLoc("");
    setSelectManager("");
    setKeyword("");
    setDeptsId("");
    setLocaId("");
    setManagerIds("");
    props.searchKeyword("")
    setSelectAlpha(null)
    var req = {
      Keyword: "",
      Alphabet: null,
      DepartmentName: "",
      Location: "",
      ReportingManagerId: "",
      IsActive: isActive,
      Page: 1,
      ResultsPerPage: 7,
    };
    props.reset(req);
  };

  const downloadEmployeeDetails = () => {
    var Deptval = [];
    if (selectDept.length > 0) {
      selectDept.map((option) => {
        Deptval.push(option.value);
        setDeptsId(Deptval.toString());
        props.selectDepartment(Deptval.toString());
      });
    }
    var Locval = [];
    if (selectLocation.length > 0) {
      selectLocation.map((option) => {
        Locval.push(option.value);
        setLocaId(Locval.toString());
        props.selectLoation(Locval.toString());
      });
    }
    var Managerval = [];
    if (selectManager.length > 0) {
      selectManager.map((option) => {
        Managerval.push(option.value);
        setManagerIds(Managerval.toString());
        props.selectManager(Managerval.toString());
      })
    }

    var req = {
      Keyword: keyword,
      Alphabet: selectAlpha,
      DepartmentName: selectDept.length > 0 ? Deptval.toString() : deptIds,
      Location: selectLocation.length > 0 ? Locval.toString() : locaIds,
      ReportingManagerId: selectManager.length > 0 ? Managerval.toString() : managerIds,
      IsActive: isActive,
      Page: 1,
      ResultsPerPage: 6,
      isDownload: true
    };
    if (isError === false && isKeywordError === false) {
      axiosFetch({
        method: "POST",
        url: "/employees/search",
        requestConfig: req,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data)
            const result = res.data.profiles.map(({
              createdDate,
              createdby,
              createdbyNavigation,
              currentCtc,
              department,
              departmentCode,
              departmentId,
              departmentImage,
              description,
              employeeCode,
              employeeLevel,
              employeeLevelId,
              employeeTypeId,
              id,
              isActive,
              isManager,
              jobTitleId,
              lastAppraiselDate,
              linkedIn,
              modifiedDate,
              modifiedby,
              modifiedbyNavigation,
              notifyUser,
              officeLocation,
              officeLocationId,
              originalPhotoName,
              parent,
              password,
              personalEmailId,
              profilePhotoName,
              reportingManger,
              reportingMangerId,
              reportingPersonDepartmentName,
              reportingPersonEmailId,
              reportingPersonEmpCode,
              reportingPersonId,
              reportingPersonJobTitle,
              reportingPersonTeam,
              team,
              teamCount,
              teamId,
              user,
              userId,
              userType,
              userTypeId,
              yearOfExperience,
              zoomId, ...rest
            }) => {
              console.log(rest);
              return rest;

            });

            let header = ["Empolyee Number", "Employee First Name", "Employee Last Name", "Email Address", "Designation", "Department Name", "", "Reporting Manager First Name", "Reporting Manager Last Name", "location", "Date of Joined", "Phone Number", "Other email Address"]
            var wb = XLSX.utils.book_new(),
              ws = XLSX.utils.sheet_add_json(ws, result, { origin: 'A2', skipHeader: true });
            XLSX.utils.sheet_add_aoa(ws, [header]);
            XLSX.utils.book_append_sheet(wb, ws, "Employees");
            XLSX.writeFileXLSX(wb, "EmployeeDetails.xlsx");




          }
          if (res.status === 400) {
            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          }
          if (res.status === 401) {
            // navigate("/");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const applyFilter = () => {
    setIsDownloadable(false)
    var Deptval = [];
    if (selectDept.length > 0) {
      selectDept.map((option) => {
        Deptval.push(option.value);
        setDeptsId(Deptval.toString());
        props.selectDepartment(Deptval.toString());
      });
    }
    var Locval = [];
    if (selectLocation.length > 0) {
      selectLocation.map((option) => {
        Locval.push(option.value);
        setLocaId(Locval.toString());
        props.selectLoation(Locval.toString());
      });
    }
    var Managerval = [];
    if (selectManager.length > 0) {
      selectManager.map((option) => {
        Managerval.push(option.value);
        setManagerIds(Managerval.toString());
        props.selectManager(Managerval.toString());
      })
    }

    var req = {
      Keyword: keyword,
      Alphabet: selectAlpha,
      DepartmentName: selectDept.length > 0 ? Deptval.toString() : deptIds,
      Location: selectLocation.length > 0 ? Locval.toString() : locaIds,
      ReportingManagerId: selectManager.length > 0 ? Managerval.toString() : managerIds,
      IsActive: isActive,
      Page: 1,
      ResultsPerPage: 6,
      isDownload: false
    };
    if (isError === false && isKeywordError === false) {
      props.filterUser(req);
    }
  };

  const handleKeyword = (e) => {
    setKeyword(e.target.value);
    props.searchKeyword(e.target.value);
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    if (format.test(e.target.value)) {
      setIsKeywordError(true);
    } else {
      setIsKeywordError(false);
    }
  };
  const handleDeptSelect = (selected) => {
    if (selected.length > 0) {
      setSelectDept(selected);

    }
    else {
      setSelectDept(selected);
      setDeptsId("");
      props.selectDepartment("");
    }
  };
  const handleLocationSelect = (selected) => {
    if (selected.length > 0) {
      setSelectLoc(selected);
    }
    else {
      setSelectLoc(selected);
      setLocaId("");
      props.selectLoation("");
    }
    console.log(selected)
  };
  const handleManagerSelect = (selected) => {
    if (selected.length > 0) {
      setSelectManager(selected)
    }
    else {
      setSelectManager(selected)
      setManagerIds("");
      props.selectManager("");
    }
  }
  const handleAlphaSearch = (alpha) => {
    setSelectAlpha(alpha === "All" ? null : alpha)
    props.onAlphaSearch(alpha === "All" ? null : alpha)
  }
  return (
    <div className="argus-filter-employee">
      <ValidatorForm onSubmit={() => applyFilter()}>
        <Box>
          <Grid container alignItems="center">
            <Grid xs={6} alignItems="center">
              <h3 className="filter-heading">Filters</h3>
            </Grid>
            <Grid xs={6} alignItems="center">
              <Link
                className="clear-all-link"
                to=""
                onClick={() => resetFilter()}
              >
                Clear All
              </Link>
            </Grid>
            <Grid xs={12} className="grid-margins">
              <TextField
                fullWidth
                id="standard-basic"
                placeholder="Search"
                variant="outlined"
                error={isKeywordError}
                helperText={
                  isKeywordError ? "Special Characters Not Allowed" : ""
                }
                value={keyword}
                onChange={handleKeyword}
              // InputProps={{ style: { fontSize: 12 } }}
              // InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </Grid>
            <Grid xs={12} className="grid-margins">
              <FormControl variant="outlined" fullWidth>
                {/* <InputLabel id="demo-simple-select-standard-label">
                Search by Department
              </InputLabel> */}
                <Select
                  placeholder={
                    <div className="select-placeholder-text">
                      Search by Department
                    </div>
                  }
                  name="Department"
                  value={selectDept}
                  options={departments}
                  onChange={handleDeptSelect}
                  isMulti="true"
                  menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                // InputProps={{ style: { fontSize: 12 } }}
                // InputLabelProps={{ style: { fontSize: 12 } }}
                />
              </FormControl>
            </Grid>
            <Grid xs={12} className="grid-margins">
              <FormControl variant="outlined" fullWidth>
                {/* <InputLabel id="demo-simple-select-standard-label">
                Search by Location
              </InputLabel> */}
                <Select
                  placeholder={
                    <div className="select-placeholder-text">
                      Search by Location
                    </div>
                  }
                  name="Location"
                  value={selectLocation}
                  options={locations}
                  onChange={handleLocationSelect}
                  isMulti="true"
                  menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                // InputProps={{ style: { fontSize: 12 } }}
                // InputLabelProps={{ style: { fontSize: 12 } }}
                ></Select>
              </FormControl>
            </Grid>
            <Grid xs={12} className="grid-margins">
              <FormControl variant="outlined" fullWidth>
                <Select
                  placeholder={
                    <div className="select-placeholder-text">
                      Search by Reporting Manager
                    </div>
                  }
                  labelId="demo-simple-select-standard-label"
                  name="ReportingManager"
                  value={selectManager}
                  options={reportingManager}
                  onChange={handleManagerSelect}
                  isMulti="true"
                  menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                // InputProps={{ style: { fontSize: 12 } }}
                // InputLabelProps={{ style: { fontSize: 12 } }}
                ></Select>
              </FormControl>
            </Grid>
            <Grid xs={12} className="grid-margins">

            </Grid>
            <Grid xs={12} className="grid-margins">
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox onChange={handleInactiveUser} />}
                  label="Show Inactive Users"
                />
              </FormGroup>
            </Grid>
            <Grid
              xs={12}
              className="grid-margins"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Button
                type="submit"
                style={{ marginTop: "0px !important", marginRight: "5px" }}
                variant="contained"
                className="theme-btn"
              // onClick={() => applyFilter()}
              >
                Filter
              </Button>
              {(isUserLogged.usertype === "Admin" ||
                isUserLogged.usertype === "SuperAdmin"
                || isUserLogged.usertype === "HRManager"
              ) && isDownloadable === false ? <Button
                onClick={downloadEmployeeDetails}
                style={{ marginTop: "0px !important" }}
                variant="contained"
                className="theme-btn"
              >
                Download
              </Button> : ""}
            </Grid>
            {/* <Grid
              xs={12}
              className="grid-margins"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              
            </Grid> */}
            <hr />
            {/* <Grid xs={12} className="grid-margins">
            <Stack>
              <h4 className="filter-option-heading">Search by Alphabet</h4>
              <Stack direction="column" spacing={3} className="d-block-class">
                {alphabets.map((alpha) => {
                  return (
                    <Chip
                      key={alpha}
                      label={alpha}
                      color={alpha === selectAlpha?"secondary":"primary"}
                      value={alpha}
                      onClick={() =>
                        handleAlphaSearch(alpha)
                        // props.onAlphaSearch(alpha === "All" ? null : alpha)
                      }
                    />
                  );
                })}
              </Stack>
            </Stack>
          </Grid> */}
          </Grid>
        </Box>
      </ValidatorForm>
    </div>
  );
}
export default Filter;
